import React, { createContext, useContext, useState, useCallback } from 'react';

interface ActiveLiveRoomState {
  /** Whether the current user is hosting an active live room */
  isHostingLive: boolean;
  /** The room ID the host is in */
  activeRoomId: string | null;
  /** Set hosting state when entering a live room as host */
  setHostingLive: (roomId: string) => void;
  /** Clear hosting state when properly leaving/ending */
  clearHostingLive: () => void;
}

const ActiveLiveRoomContext = createContext<ActiveLiveRoomState>({
  isHostingLive: false,
  activeRoomId: null,
  setHostingLive: () => {},
  clearHostingLive: () => {},
});

export function ActiveLiveRoomProvider({ children }: { children: React.ReactNode }) {
  const [activeRoomId, setActiveRoomId] = useState<string | null>(null);

  const setHostingLive = useCallback((roomId: string) => {
    setActiveRoomId(roomId);
  }, []);

  const clearHostingLive = useCallback(() => {
    setActiveRoomId(null);
  }, []);

  return (
    <ActiveLiveRoomContext.Provider
      value={{
        isHostingLive: !!activeRoomId,
        activeRoomId,
        setHostingLive,
        clearHostingLive,
      }}
    >
      {children}
    </ActiveLiveRoomContext.Provider>
  );
}

export function useActiveLiveRoom() {
  return useContext(ActiveLiveRoomContext);
}
